import React from 'react'

import { ITableHead, Head } from 'components/layout/table/head'

interface IProps {
  head: ITableHead[]
}

const headExists = (head: Array<ITableHead>) =>
  head.reduce((prev, elem) => {
    if (!elem.label) {
      return false
    }
    return true
  }, true)

const TableResultHead: React.FC<IProps> = (props) => {
  const { head } = props

  if (headExists(head)) {
    return (
      <div className="w-full flex px-48 mt-25 mb-10">
        {head.map((item) => {
          return (
            <span
              key={item.key}
              className={`w-${item.col}/12 tracking-0.32 font-400 ${
                Head.prototype.isHighlight(item) ? 'text-brand-primary' : 'text-black'
              } text-12 text-right`}
            >
              {item.label}
            </span>
          )
        })}
      </div>
    )
  }
  return null
}

export default TableResultHead
